var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocusign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8869 15.8819V20.3931C15.8869 20.63 15.6955 20.8214 15.4586 20.8214H3.60192C3.36497 20.8214 3.17358 20.63 3.17358 20.3931V8.54552C3.17358 8.30857 3.36497 8.11719 3.60192 8.11719H8.10399V15.4536C8.10399 15.6905 8.29537 15.8819 8.53232 15.8819H15.8869Z",
    fill: "#4C00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8265 9.52076C20.8265 13.312 18.6119 15.8729 15.887 15.882V11.1065C15.887 10.9698 15.8323 10.8331 15.732 10.742L13.2532 8.26309C13.1529 8.16285 13.0253 8.10816 12.8886 8.10816H8.11316V3.60609C8.11316 3.36914 8.30454 3.17776 8.54149 3.17776H15.2217C18.3932 3.16865 20.8265 5.72043 20.8265 9.52076Z",
    fill: "#FF5252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.732 10.7321C15.8323 10.8324 15.887 10.9599 15.887 11.0967V15.8721H8.54149C8.30454 15.8721 8.11316 15.6807 8.11316 15.4438V8.10742H12.8886C13.0253 8.10742 13.162 8.1621 13.2532 8.26235L15.732 10.7321Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocusign);
export default __webpack_public_path__ + "static/media/Docusign.35170755228b2ef38cf62c89c2fd7b9b.svg";
export { ForwardRef as ReactComponent };